/**
 * @generated SignedSource<<e8aceb17ebd4e7e2c2d874aebfe9a1e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_viewer" | "ItemTileCarousel_viewer">;
  readonly " $fragmentType": "SharedItemTile_viewer";
};
export type SharedItemTile_viewer$key = {
  readonly " $data"?: SharedItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTileCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1e74d108231a3c76d92b49c159aec935";

export default node;
